import React, { useState } from 'react';
import '../../styles/about/hero.css';
import about640Webp from '../../assets/img/about-640.webp';
import about1920Webp from '../../assets/img/about-1920.webp';
import about2560Webp from '../../assets/img/about-2560.webp';

const HeroSection = () => {
	const [loaded, setLoaded] = useState(false);

	const handleScroll = () => {
		const overviewSection = document.getElementById('overview');
		if (overviewSection) overviewSection.scrollIntoView({ behavior: 'smooth' });
	};

  return (
		<section id="about-hero" className="about-hero">
		<div className={`about-hero-picture ${loaded ? 'is-loaded' : ''}`}>
			<img
				src={about640Webp}
				srcSet={`${about1920Webp} 1920w, ${about2560Webp} 2560w`}
				sizes="100vw"
				alt="Proteomics research background"
				loading="eager"
				fetchpriority="high"
				decoding="async"
				className="about-hero-img"
				onLoad={() => setLoaded(true)}
			/>
			<div className="about-hero-overlay" />
		</div>

		<div id="about-hero-content" className="about-hero-content">
			<h1>Revolutionizing Cancer Diagnostics with Proteome Medicine Sweden (ProMS)</h1>
			<p>A National Effort to Transform Cancer Care through Proteomics</p>
			<button className="about-cta-button" onClick={handleScroll}>
				LEARN MORE
			</button>
		</div>
		</section>
	);
};

export default HeroSection;
